var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-textarea',_vm._b({on:{"input":v => _vm.$emit('input', v)}},'input-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }